import { useModelApi, UseModelApiProps } from '@melio/api-client';
import { Subscription, SubscriptionsApiClient } from '@melio/platform-api-axios-client';

type QueryFN = (_?: string) => ReturnType<typeof SubscriptionsApiClient.getSubscriptionsMe>;
type CreateFn = typeof SubscriptionsApiClient.postSubscriptions;

export type UseSubscriptionMeProps = UseModelApiProps<QueryFN, Subscription>;

export const useSubscriptionMe = (props: UseSubscriptionMeProps = {}) =>
  useModelApi<QueryFN, never, never, CreateFn>({
    ...props,
    id: 'me',
    queryKey: ['SubscriptionsApi', 'me'],
    queryFn: () => SubscriptionsApiClient.getSubscriptionsMe(),
    createFn: SubscriptionsApiClient.postSubscriptions,
    cacheTime: Infinity,
    staleTime: Infinity,
  });
